export default {
    BankTransfersBrokers:[],
   // Packages:[],
    BankTransfersBroker:{},
    BankTransfersSPs:[],
    BankTransfersSP:{}
  }